import { render, staticRenderFns } from "./page-pricing.vue?vue&type=template&id=26ccf221&"
import script from "./page-pricing.vue?vue&type=script&lang=js&"
export * from "./page-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports